export default "__VITE_ASSET__BC7PRKsa__ 480w, __VITE_ASSET__D__rmKFC__ 768w, __VITE_ASSET__B$s7INLO__ 1200w, __VITE_ASSET__BrS1s4CE__ 1920w";